import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataAlertInfo } from '../models/IDataAlertInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { IErrorDetail } from './ContentActionNotification';

export class ResumeDataAlertsAction {

  public static $inject = [
    'ActionHelpers',
    'ConfirmActionDialog',
    'DataAlerts',
    '$translate',
  ];

  constructor(
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private DataAlerts: DataAlerts,
    private $translate: ng.translate.ITranslateService) { }

  public resumeDataAlerts(alerts: Set<IDataAlertInfo>, context: IActionContext): ng.IPromise<IResult> {

    return this.DataAlerts.resumeAlerts(alerts.keys());
  }

  private notifyResult(alerts: Set<IDataAlertInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      alerts,
      {
        successId: 'resumeDataAlertsSuccess',
        errorId: 'resumeDataAlertsError'
      },
      (errorItem: IErrorItem<IDataAlertInfo>) => this.errorDetailFor(errorItem)
    )(result);
  }

  private errorDetailFor(errorItem: IErrorItem<IDataAlertInfo>): IErrorDetail {
    const itemName = errorItem.item.name;
    let errorMessage: string;

    switch (errorItem.error.code) {
      case CommonErrorCode.DataAlertNotFound:
        errorMessage = this.$translate.instant('errorDataAlertNotFound', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      default:
        errorMessage = this.$translate.instant('errorUnknown');
    }

    return { itemName, errorMessage };
  }

}

Module.instance().service('ResumeDataAlertsAction', ResumeDataAlertsAction);
